export const Service = {
  getConfig: function(url) {
    //return API.get("/dashboard/config").finally(() => {});
    return fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        return myJson;
      });
  }
};
